/** P0 — thin entry: no App import (avoids circular TDZ in prod bundle). */
import { setAuthTokenGetter, setCountryCodeGetter } from "@workspace/api-client-react";
import { bootstrapFoodPerf } from "./lib/foodPerfBootstrap";
import { isFoodSurfacePath } from "./lib/isFoodSurfacePath";
import { setAppShell } from "./lib/appShell";
import { bootstrapDocumentTheme, readStoredDarkMode, applyDocumentTheme } from "./lib/themeBootstrap";
import { installClientErrorCapture } from "./lib/clientErrorCapture";

const CHUNK_RELOAD_KEY = "tasallot_chunk_reload";
const CHUNK_RELOAD_MAX = 2;

installClientErrorCapture();
bootstrapDocumentTheme();

const foodSurface = isFoodSurfacePath();
if (foodSurface) setAppShell("food");
bootstrapFoodPerf();

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  try {
    const attempts = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? "0");
    if (attempts < CHUNK_RELOAD_MAX) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, String(attempts + 1));
      const url = new URL(window.location.href);
      url.searchParams.set("_cb", String(Date.now()));
      window.location.replace(url.toString());
      return;
    }
  } catch {
    /* sessionStorage blocked */
  }
  showBootstrapFailure(
    event instanceof ErrorEvent && event.error instanceof Error
      ? event.error
      : new Error("Failed to load application bundle"),
  );
});

setAuthTokenGetter(() => {
  try { return localStorage.getItem("tasallot_token"); } catch { return null; }
});

setCountryCodeGetter(() => {
  try { return localStorage.getItem("tasallot_country_code"); } catch { return null; }
});

function showBootstrapFailure(error: unknown) {
  const root = document.getElementById("root");
  if (!root) return;
  applyDocumentTheme(readStoredDarkMode());
  const message = error instanceof Error ? error.message : "Application failed to start";
  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:inherit;color:inherit;font-family:system-ui,sans-serif;direction:rtl">
      <div style="max-width:420px;text-align:center">
        <div style="font-size:48px;margin-bottom:12px">⚠️</div>
        <h1 style="font-size:22px;font-weight:800;margin:0 0 8px">خطا در بارگذاری سایت</h1>
        <p style="font-size:14px;color:#64748B;margin:0 0 16px">${message.replace(/</g, "&lt;")}</p>
        <button type="button" onclick="location.reload()" style="padding:10px 20px;border:0;border-radius:12px;background:#1FA84A;color:#fff;font-weight:700;cursor:pointer">تلاش مجدد</button>
      </div>
    </div>`;
}

void import("./bootstrap")
  .then(m => m.startApp())
  .catch(showBootstrapFailure);
